import { render, staticRenderFns } from "./CommonAssetsTemplate.vue?vue&type=template&id=76a432bf&scoped=true&"
import script from "./CommonAssetsTemplate.vue?vue&type=script&lang=js&"
export * from "./CommonAssetsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CommonAssetsTemplate.vue?vue&type=style&index=0&id=76a432bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a432bf",
  null
  
)

export default component.exports